import { ConfigProvider, Modal, Spin, message } from "antd";
import { Dispatch, SetStateAction, useEffect, useState, useCallback } from "react";
import container from "@/lib/di/container";
import { ElectronicContractRepo } from "@/core/repos/tables/electronic-contract.repo";
import React from "react";
import { MODAL_THEME } from "@/core/themes/modal.theme";

const electronicContractRepo = container.get(ElectronicContractRepo);

interface ViewDocumentModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    contractId: string,
}

export const ViewDocumentModal: React.FC<ViewDocumentModalProps> = ({isModalOpen, setIsModalOpen, contractId}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [documentUrl, setDocumentUrl] = useState<string>("");
    const [messageApi, contextHolder] = message.useMessage();

    const loadDocument = useCallback(async () => {
        setLoading(true);
        try {
            const url = await electronicContractRepo.viewDocument({ electronicContractId: contractId, type:2 });
            if (url) {
                // Check if it's a base64 data URL or regular URL
                if (url.startsWith('data:') || url.startsWith('http://') || url.startsWith('https://')) {
                    setDocumentUrl(url);
                } else {
                    // Assume it's base64 data and create a data URL
                    setDocumentUrl(`data:application/pdf;base64,${url}`);
                }
            } else {
                messageApi.error({
                    content: "Không thể tải tài liệu"
                });
            }
        } catch (error) {
            messageApi.error({
                content: "Lỗi khi tải tài liệu"
            });
        } finally {
            setLoading(false);
        }
    }, [contractId, messageApi]);

    useEffect(() => {
        if (isModalOpen && contractId) {
            loadDocument();
        } else {
            setDocumentUrl("");
        }
    }, [isModalOpen, contractId, loadDocument]);

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <ConfigProvider theme={MODAL_THEME}>
            {contextHolder}
            <Modal 
                open={isModalOpen} 
                onCancel={handleCancel} 
                width={1200} 
                centered
                styles={{
                    mask: {
                        backdropFilter: 'blur(2px)',
                        backgroundColor: 'var(--primary-mask)'
                    }
                }}
                footer={null}
            >
                <div className="flex flex-row w-full items-center justify-start select-none mb-4">
                    <p className="ml-2 text-2xl font-bold text-primary">XEM TÀI LIỆU HỢP ĐỒNG</p>
                </div>
                {loading ? (
                    <div className="flex justify-center items-center py-12">
                        <Spin size="large" />
                    </div>
                ) : documentUrl ? (
                    <div className="w-full" style={{ height: '70vh' }}>
                        <iframe
                            src={documentUrl}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                            title="Document Viewer"
                        />
                    </div>
                ) : (
                    <div className="text-center py-12">
                        <p>Không có tài liệu để hiển thị</p>
                    </div>
                )}
            </Modal>
        </ConfigProvider>
    );
};

